import React from 'react';
import { toUrl } from '../services/navigation';
import { translate } from '../services/builders';

function Pager({ entries, search, settings }) {
	const pageCount = Math.ceil(parseInt(entries.totalCount) / parseInt(entries.pageSize));	
	const entriesPageIndex = parseInt(entries.pageIndex);
	const entriesPageSize = parseInt(entries.pageSize);

	const currentPage = entriesPageIndex + 1;
	const showPrev = (entriesPageIndex > 0);


	const showNext = (currentPage < pageCount);
	const showLast = (currentPage < pageCount - 2);
	
	const pages = [];
	let counter = 0;

	while (counter < 3 && counter + currentPage <= pageCount) {
		pages[counter] = counter;
		counter += 1;
	}

	var prevPages = [];
	let prevCounter = currentPage;
	let i = currentPage == 3 ? currentPage -1 : currentPage -2;
	while (prevCounter > i && currentPage >= 3) {
		prevPages[prevCounter] = prevCounter;
		prevCounter--;
	}

	function scrollTop(){
		//window.scrollTo(0, 0);
	}

	//<p classNameName="paging__info">Showing {parseInt(entries.pageSize) * entriesPageIndex + 1} to {showNext ? parseInt(entries.pageSize) * (entriesPageIndex + 1) : parseInt(entries.totalCount)} of {parseInt(entries.totalCount)}</p>
	
	return (
		<nav aria-label="Pagination control" className="pagination">
			{showPrev && <a className="pagination__link pagination__control pagination__prev" onClick={scrollTop()} aria-label="Previous Page" href="#" href={toUrl(search, { pageIndex: entriesPageIndex - 1 }, settings)}>
				<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-chevron-right">
					<use xlinkHref="#icon-chevron-right"></use>
				</svg>
				<span className="visuallyhidden">
				Back
				</span>
			</a>}		
			<ul className="pagination__list">	
			{showPrev && function(){
				const pagerClass = currentPage > 2 ? 'pagination__item paging__first' : 'pagination__item'; 
				return (<li className={pagerClass}><a aria-label='Go To Page 1' onClick={scrollTop()} href={toUrl(search, { pageIndex: 0 }, settings)} className="pagination__link">1</a></li>)
			}()}
			{currentPage >= 1 && prevPages.map((_, pageIndex) => {
				pageIndex = _ - 2;
				return (<li className="pagination__item" key={pageIndex}><a aria-label={'Go To Page' + (pageIndex + 1)} onClick={scrollTop()} href={toUrl(search, { pageIndex }, settings)} className="pagination__link">{pageIndex + 1}</a></li>);
			})}
			{pageCount > 1 && pages.map((_, pageIndex) => {
				pageIndex =	currentPage - 1 + pageIndex;			
				let active = (pageIndex === entriesPageIndex) ? "pagination__link active" : "pagination__link";
				let label = (pageIndex === entriesPageIndex) ? 'Current Page': 'Go To Page' + (pageIndex + 1);
				return (<li className="pagination__item" key={pageIndex}><a aria-label={label} onClick={scrollTop()} href="#" href={toUrl(search, { pageIndex }, settings)} className={active}>{pageIndex + 1}</a></li>);
			})}
			{showLast && function(){
				const pagerClass = currentPage < pageCount - 3 ? 'pagination__item pagination__last' : 'pagination__item'; 
				return(<li className={pagerClass}><a aria-label={'Go To Page' + pageCount} onClick={scrollTop()} href="#" href={toUrl(search, { pageIndex: pageCount - 1 }, settings)} className="pagination__link">{pageCount}</a></li>)
			}()}	
			</ul>
			{showNext && <a className="pagination__link pagination__control pagination__next" onClick={scrollTop()} aria-label="Next Page" href="#"  href={toUrl(search, { pageIndex: entriesPageIndex + 1 }, settings)}>
				<span className="visuallyhidden">
				Next
				</span>
				<svg xmlns="http://www.w3.org/2000/svg" className="icon icon-chevron-right">
					<use xlinkHref="#icon-chevron-right"></use>
				</svg>
			</a>}		
		</nav>
	);
}



export default Pager;